import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import GenericButton from '../../../../../../Components/GenericButton/GenericButton';
import CardView from './CardView/CardView';
import DummyView from './CardView/DummyCard';
import { CloseSideBarSVG, ExpandSideBarSVG } from './BottomSideBarSVG';
/*import { useDispatch } from 'react-redux';
import {
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
} from '../../../../../../redux/member/enrollmentPlanCompareSlice';*/
import './BottomSideBar.scss';
import { useNavigate } from 'react-router-dom';

//{
//selectedCheckedItems,
//selectedCheckedRowData,
//setSelectedCheckedItems,
//setSelectedCheckedRowData,
//}
const BottomSideBar = ({
  selectedCheckedItems,
  selectedCheckedRowData,
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
  setShowComparePlans,
  setSelectedCompareProducts,
  selectedTab,
  setCompareTabName,
}) => {
  //const dispatch = useDispatch();
  //console.log('BottomSideBar selectedCheckedItems', selectedCheckedItems);
  //const { t } = useTranslation();
  const navigate = useNavigate();
  const isItemsSelected = selectedCheckedItems.length > 0;
  const isCompareDisabled = selectedCheckedItems.length < 2;
  const staticArray = Array(3).fill(1);

  const [open, setOpen] = useState(false);

  const toggleSideBarHandler = () => {
    setOpen(!open);
  };

  const removeAll = () => {
    //dispatch(setSelectedCheckedItems([]));
    //dispatch(setSelectedCheckedRowData([]));
    setSelectedCheckedItems([]);
    setSelectedCheckedRowData([]);
  };

  useEffect(() => {
    if (!isItemsSelected) {
      setOpen(false);
    }
  }, [isItemsSelected]);

  useEffect(() => {
    //Need to clear the selected items while unmounting
    return () => {
      //removeAll();
    };
  }, []);

  const handleCompareResult = () => {
    /*navigate('/admin/price-compare/show-result', {
      state: {
        from: 'search',
      },
    });*/
    console.log(
      'handleCompareResult selectedCheckedRowData',
      selectedCheckedRowData,
    );
    setShowComparePlans(true);
    setSelectedCompareProducts(selectedCheckedRowData);
    setCompareTabName(selectedTab);
  };

  return (
    <div
      aria-label="compare price tool panel"
      className={`bottom-sidebar-wrapper ${open && 'collapsed-bar'} ${
        isItemsSelected ? 'sidebar-open' : 'sidebar-close'
      }`}
    >
      <div className="container">
        <div className="top-section">
          <div className="top-section-wrapper">
            <div className="blueTitle">
              Compare Plans{' '}
              {open && (
                <span className="mobile-selected-count">
                  ({selectedCheckedItems.length})
                </span>
              )}
            </div>
            <div
              className={`arrow-bg ${open && 'down-arrow'}`}
              role="button"
              aria-label="Click to expand and collapse the panel"
              onClick={() => toggleSideBarHandler()}
              tabIndex={0}
              aria-expanded={!open}
            >
              <ExpandSideBarSVG />
            </div>
          </div>
          {open && (
            <div role="status" className="top-sub-section-collapsed">
              You have selected {selectedCheckedItems.length} out of 3 options.
            </div>
          )}
          <div className="right-section">
            <div
              className="remove-all"
              role="button"
              onClick={() => removeAll()}
            >
              Remove All <span className="sr-only"> the selected plans</span>
            </div>
            <div
              aria-label="Remove all the selected plans and close the panel"
              role="button"
              className="closeIconPosition"
              onClick={() => removeAll()}
            >
              <CloseSideBarSVG className="closeIcon" />
            </div>
          </div>
        </div>
        <div className="middle-section">
          {selectedCheckedRowData && (
            <div className="card-wrapper">
              {staticArray.map((item, index) => (
                <div
                  className={`${
                    selectedCheckedRowData && selectedCheckedRowData[index]
                      ? 'card-item card-info-item'
                      : 'card-item card-dummy-item'
                  }`}
                  key={`item-${index}`}
                >
                  {selectedCheckedRowData && selectedCheckedRowData[index] ? (
                    <CardView
                      data={selectedCheckedRowData[index]}
                      selectedCheckedItems={selectedCheckedItems}
                      selectedCheckedRowData={selectedCheckedRowData}
                      setSelectedCheckedItems={setSelectedCheckedItems}
                      setSelectedCheckedRowData={setSelectedCheckedRowData}
                      selectedTab={selectedTab}
                    />
                  ) : (
                    <DummyView />
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="bottom-section">
          <GenericButton
            disable={isCompareDisabled}
            buttonDisabled={isCompareDisabled}
            ariaLabel={
              isCompareDisabled
                ? 'Select a minimum of 2 and maximum of 3 plans'
                : 'Click to compare the selected plans'
            }
            onClick={() => {
              handleCompareResult();
            }}
          >
            COMPARE
          </GenericButton>
          <div className="remove-all" onClick={() => removeAll()}>
            Remove All
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomSideBar;
